import axios from "axios";
import Config from "src/config";

const v2_actionAutomacoes = (clienteId) => {
    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/clientes/${clienteId}/automacoes`
    });
};

export default v2_actionAutomacoes;
